import { createSlice } from "@reduxjs/toolkit";

const mainSlice = createSlice({
  name: "user",
  initialState: {
    collapsed: false,
    collapsedHead: false,
  },
  reducers: {
    setCollapsed(state, action) {
      state.collapsed = action.payload;
    },
    setCollapsedHead(state, action) {
      state.collapsedHead = action.payload;
    },
  },
});

export const { setCollapsed ,setCollapsedHead } = mainSlice.actions;
export default mainSlice.reducer;
